import {
	Box,
	Button,
	FixedMenu,
	IconAngleDown,
	IconEmojiWarning,
	IconFav,
	IconInformation,
	IconLock,
	IconPlace,
	IconWhats,
	MenuItem,
	SideBar,
	SideBarMenuItem,
	SideBarTitle,
	Text,
	UserBadge,
} from 'condolivre-ds';
import iconCarteira from 'condolivre-ds/build/static/icon/icon_sm_carteira.svg';
import iconHome from 'condolivre-ds/build/static/icon/icon_sm_home.svg';
import iconLogout from 'condolivre-ds/build/static/icon/icon_sm_logout.svg';
import iconCadastroWhite from '../../../public/images/icon_sm_cadastro_white.svg';
import Image from 'next/image';
import { useRouter } from 'next/router';
import React from 'react';
import { Col, Container, Hidden, Row } from 'react-grid-system';
import { useGetMeQuery } from '../../../generated';
import { getUser } from '../../helpers/index';
import { getTagScreen, gtmShootEvent } from '../../helpers/tag';
import Footer from '../Footer/Footer';
import styles from './Layout.module.scss';
import { networkOptions } from './network';
import { usePartner } from '../../providers/Partner';
import Head from 'next/head';
import { sidebar } from 'condolivre-ds/build/themes/default';
import styled from 'styled-components';
import { css } from '@emotion/css';

interface LayoutProps {
	children?: any;
	isAuthenticated?: boolean;
	internalPage?: boolean;
	internalPageName?: string;
	backTo?: string;
	className?: any;
	header?: boolean;
	showSidebar?: boolean;
	noFooter?: boolean;
	showModal?: any;
	loaderAnimation?: boolean;
}

const CustomSidebar = styled(SideBar)<{ bgcolor?: string }>`
	background-color: ${props => props.bgcolor};
`;

const CustomSideBarMenuItem = styled(SideBarMenuItem)<{ bgcolor?: string }>`
	background-color: ${props => props.active && props.bgcolor};
`;

const CustomFixedMenu = styled(FixedMenu)<{ bgcolor?: string }>`
	background-color: ${props => props.bgcolor};
`;

const CustomMenuItem = styled(MenuItem)<{ bgcolor?: string }>`
	background-color: ${props => props.active && props.bgcolor};
`;

const CustomContainer = styled(Container)<{ bgcolor?: string }>`
	background-color: ${props => props.bgcolor};
`;

const CustomCol = styled(Col)<{ bgcolor?: string }>`
	background-color: ${props => props.bgcolor};
`;

const CustomExitButton = styled(Button)<{
	iconBgcolor?: string;
	bgcolor?: string;
}>`
	background-color: ${props => props.bgcolor};
	> div > div {
		background-color: ${props => props.iconBgcolor};
	}
`;

export const Layout: React.FC<LayoutProps> = props => {
	const user = getUser();
	const router = useRouter();
	const { logo, name, sidebar, theme, header } = usePartner();
	//request getMe Query
	const { data } = useGetMeQuery({ ...networkOptions });

	const handleBack = () => {
		router.push({
			pathname: `/${props.backTo}`,
		});
	};

	const goToUserData = () => {
		shootEvent('btn-dados-cadastrais');
		router.push({
			pathname: `/user-profile`,
		});
	};

	const goToGeneral = () => {
		router.push({
			pathname: `/general`,
		});
	};

	const shootEvent = (id: any) => (e: any) => {
		gtmShootEvent({
			screen: getTagScreen(window.location.pathname),
			label: id,
			section: null,
			payload: null,
		});
	};

	const renderModalAnimated = () => {
		return (
			<Box
				className={styles.confirmation__modal_loader}
				data-type="restrain-style">
				<Row>
					<Col lg={12}>
						<Image
							src={props.showModal?.loaderImgPath}
							width={120}
							height={120}
							alt="Condo Livre"
						/>
					</Col>
				</Row>

				<Row>
					<Col lg={12} className={styles.bar_loader}>
						<div className={styles.detailsOngoing__progress_bar}>
							<div
								className={styles.detailsOngoing__progress_front}
								style={{ maxWidth: '8%' }}></div>
							<div className={styles.detailsOngoing__progress_back}></div>
						</div>
						<Text weight="500" size="v_18">
							{props.showModal?.loaderMessage}
						</Text>
					</Col>
				</Row>
			</Box>
		);
	};

	const renderInfoModal = () => {
		return (
			<Box className={styles.confirmation__modal} data-type="restrain-style">
				<Row>
					<Col lg={12}>
						{props.showModal?.loaderImgPath ? (
							<Image
								src={props.showModal?.loaderImgPath}
								width={60}
								height={60}
							/>
						) : (
							<IconEmojiWarning className={styles.confirmation__emoji} />
						)}
					</Col>
				</Row>
				<Row>
					<Col lg={12}>
						<Text
							className={styles.confirmation__title}
							color="gray_900"
							size="v_26"
							weight="v_600">
							{props.showModal?.title ? props.showModal?.title : 'Atenção!'}
						</Text>
						<Text
							className={styles.confirmation__subtitle}
							color="gray_900"
							size="v_20"
							weight="v_400">
							{props.showModal?.message}
						</Text>
						{props.showModal?.render && props.showModal?.render}
					</Col>
				</Row>
				<Row>
					<Col lg={12} className={styles.action}>
						{!props.showModal?.render && (
							<Button
								size="normal"
								onClick={
									props.showModal?.callToAction
										? props.showModal?.callToAction
										: goToGeneral
								}
								variant="cta">
								{props.showModal.callToActionText
									? props.showModal.callToActionText
									: 'Voltar'}
							</Button>
						)}
					</Col>
				</Row>
			</Box>
		);
	};

	if (props.isAuthenticated) {
		const menuLinks = [
			{
				label: 'Início',
				icon: iconHome.src,
				path: '/general',
				id: 'menu-inicio',
			},
			{
				label: 'Empréstimos',
				icon: iconCarteira.src,
				path: '/loans',
				id: 'menu-emprestimos',
			},
			{
				label: 'Dados cadastrais',
				icon: iconCadastroWhite.src,
				path: '/user-profile',
				id: 'menu-dados-cadastrais',
			},
		];

		return (
			<div data-type="restrain-style">
				{props.showModal?.show && <div className={styles.overlay}></div>}

				<CustomContainer
					className={styles.containerMobile}
					bgcolor={theme?.primary}>
					{props.showModal?.show && (
						<>
							{props.showModal?.loaderAnimation
								? renderModalAnimated()
								: renderInfoModal()}
						</>
					)}
					<Row>
						<CustomCol
							md={12}
							className={styles.welcomeMobile}
							bgcolor={header?.background}>
							<Image
								src={logo?.custom}
								width={logo?.width}
								height={logo?.height}
								alt={name?.standard}
							/>
						</CustomCol>
					</Row>
					<Row
						className={[
							styles.internal_wrapper,
							!props.internalPage && styles.internal_page,
						].join(' ')}>
						<Col md={12} className={[styles.wrapper].join(' ')}>
							<Button
								className={styles.internal_page_button}
								onClick={handleBack}>
								<Image
									src="/images/icon_voltar_white.svg"
									width={24}
									height={31}
									alt="Voltar"
								/>
							</Button>
							<Text weight={'v_600'} size={'v_16'} color={'white'}>
								{props.internalPageName}
							</Text>
							<div className={styles.spacer}>&nbsp;</div>
						</Col>
					</Row>
					<Row
						className={[
							props.internalPage && styles.internal_page,
							styles.headerMobile,
						].join(' ')}>
						<Col md={10} className={styles.wrapper}>
							<UserBadge
								color={'blue_50'}
								name={data?.getMe.name}
								id={'user-badge'}
							/>

							<div className={styles.hamburger_menu}>
								<input
									className={styles.menu__toggle}
									id="menu__toggle"
									type="checkbox"
								/>
								<label className={styles.menu__btn} htmlFor="menu__toggle">
									<span></span>
								</label>
								<ul
									className={styles.menu__box}
									style={{ backgroundColor: sidebar?.mobileBackground }}>
									<a href={'/logout'}>
										<CustomExitButton
											variant={'primary'}
											size={'small'}
											icon={iconLogout.src}
											id="btn-sair"
											onClick={shootEvent('btn-sair')}
											iconPos={'left'}
											bgcolor={header?.button}
											iconBgcolor={header?.icon}>
											Sair
										</CustomExitButton>
									</a>
								</ul>
							</div>
						</Col>
					</Row>
				</CustomContainer>
				<div
					className={[styles.contentWrapper].join(' ')}
					style={{ backgroundColor: theme?.tertiary }}>
					<>
						<CustomFixedMenu
							variant="collaborator"
							className={[
								styles.fixedMenu,
								props.internalPage && styles.internal_page,
							].join(' ')}
							bgcolor={sidebar?.background}>
							{menuLinks.map(({ label, icon, path, id }, index) => {
								return (
									<CustomMenuItem
										key={index}
										href={path}
										label={label}
										icon={icon}
										onClick={shootEvent(id)}
										active={router.pathname === path}
										bgcolor={sidebar?.active}
									/>
								);
							})}
						</CustomFixedMenu>
						<Hidden xs sm>
							<CustomSidebar
								className={styles.sidebar}
								variant={'consignado'}
								data-testid={'sidebar-menu'}
								bgcolor={sidebar?.background}>
								<div className={styles.logo_bar}>
									<Image
										src={sidebar?.logo?.custom}
										width={sidebar?.logo?.width}
										height={sidebar?.logo?.height}
										alt={name?.standard}
									/>
								</div>
								<SideBarTitle className={styles.sideBarTitle}>
									Portal <br />
									{sidebar?.name}
								</SideBarTitle>
								{menuLinks.map(({ label, icon, path, id }, index) => {
									return (
										<CustomSideBarMenuItem
											key={index}
											href={path}
											label={label}
											icon={icon}
											onClick={shootEvent(id)}
											active={router.pathname === path}
											bgcolor={sidebar?.active}
										/>
									);
								})}
							</CustomSidebar>
						</Hidden>
					</>

					<div
						className={[
							styles.content,
							props.className,
							props.internalPage && styles.internal_content,
						].join(' ')}>
						<Container className={styles.headerDesktop}>
							<Row>
								<Col md={10}>
									<div
										className={css`
											display: flex;
											align-items: center;
											gap: 118px;
											@media (max-width: 991px) {
												gap: 35px;
											}
											> div > div {
												&:nth-child(2) {
													> div {
														&:nth-child(1) {
															color: ${header?.user}!important;
														}
														&:nth-child(2) {
															color: ${header?.company}!important;
														}
													}
												}
											}
										`}>
										<UserBadge
											color={'blue_50'}
											name={data?.getMe.name}
											description={[
												data?.getMe.position,
												data?.getMe.company_name,
											].join('-')}
											id={'user-badge'}
										/>
									</div>
								</Col>
								<Col md={2} className={styles.justifyEnd}>
									<a href={'/logout'}>
										<CustomExitButton
											variant={'primary'}
											size={'small'}
											icon={iconLogout.src}
											id="btn-sair"
											onClick={shootEvent('btn-sair')}
											iconPos={'left'}
											bgcolor={header?.button}
											iconBgcolor={header?.icon}>
											Sair
										</CustomExitButton>
									</a>
								</Col>
							</Row>
						</Container>
						{props.children}
					</div>
				</div>

				<Footer />
			</div>
		);
	} else {
		return (
			<>
				{props.showModal?.show && (
					<>
						{props.showModal?.loaderAnimation
							? renderModalAnimated()
							: renderInfoModal()}
					</>
				)}

				{props.showModal?.show && <div className={styles.overlay}></div>}

				<div
					className={[
						styles.login,
						props.className,
						props.noFooter && styles.noFooter,
					].join(' ')}>
					{props.children}
				</div>

				{!props.noFooter && <Footer />}
			</>
		);
	}
};

Layout.defaultProps = {
	showSidebar: true,
	isAuthenticated: false,
};
